import { Type } from 'class-transformer';
import { StudentPerformanceStatus } from 'src/lib/constants/compliance';

export class FocusQueueReportMemberModel {
	student_uid: number;
	student_first_name: string;
	student_last_name: string;
	student_preferred_name: string;
	pace_status: StudentPerformanceStatus;
}

export function FocusQueueReportMemberModel_ClassTransform_Type() {
	return FocusQueueReportMemberModel;
}

export class FocusQueueReportingQueueModel {
	queue_id: number;
	queue_label: string;
	queue_type: number;
	@Type(FocusQueueReportMemberModel_ClassTransform_Type)
	members: FocusQueueReportMemberModel[];
}

export function FocusQueueReportingQueueModel_ClassTransform_Type() {
	return FocusQueueReportingQueueModel;
}

export class FocusQueueReportingModel {
	uid: number;
	first_name: string;
	last_name: string;
	@Type(FocusQueueReportingQueueModel_ClassTransform_Type)
	queues: FocusQueueReportingQueueModel[];
}
